import { NgModule } from '@angular/core'
import { HandbookTableOfContentFeatureModule } from './handbook-table-of-content/handbook-table-of-content-feature.module'
import { MacsHandbookContainerFeatureModule } from './macs-handbook-container/macs-handbook-container-feature.module'

@NgModule({
  imports: [
    HandbookTableOfContentFeatureModule,
    MacsHandbookContainerFeatureModule,
  ]
})
export class MacsHandbookRootModule {}
